<div class="home-container">
  <div class="home-header">
    <gains-title title="Home"></gains-title>
    <div class="home-actions">
      <button class="hidden" nz-button nzType="default" (click)="filter()">
        <svg-icon src="assets/icons/filter.svg" class="mr-8" />
        Filter
      </button>

      <button class="personalize disabled" nz-button nzType="default" (click)="personalize()">
        <svg-icon src="assets/icons/personalize.svg" class="mr-8" />
        Personalize
      </button>
    </div>
  </div>

  <!-- wrapper for cards to sit next to each other and wrap when necessary -->
  <div class="widgets-grid">
    <div class="widget-card" [ngClass]="chartWidgetWidthClass">
      <div class="widget-header">
        <div class="chart-title">
          <span class="title-text">On-Hand $ by Item Class</span>
        </div>
        <gains-ellipsis-menu class="ellipsis-button" [menuItems]="ellipsisDataItems" (changeEvent)="handleMenuAction($event, 'chart')"></gains-ellipsis-menu>
      </div>
      <highcharts-chart #test [options]="chartOptions" class="chart"> </highcharts-chart>
    </div>

    <!-- Days On Hand KPI Widget -->
    <kpi-widget
      [widgetTitle]="'Days On Hand'"
      [value]="daysOnHand"
      unit="days"
      [widthClass]="kpiWidgetWidthClass"
      [menuItems]="ellipsisDataItems"
      widgetId="doh"
      (changeEvent)="handleMenuAction($event, 'doh')"
    >
    </kpi-widget>

    <!-- Inventory Turnover Enhanced KPI Widget -->
    <enhanced-kpi-widget
      [widgetTitle]="'Inventory Turnover'"
      [value]="formattedCurrentTurns"
      unit="turns"
      [valueClass]="inventoryKpiValueClass"
      [widthClass]="kpiWidgetWidthClass"
      [menuItems]="ellipsisDataItems"
      widgetId="inventory-turnover"
      [hasData]="hasInventoryTurnoverData"
      [comparisonData]="inventoryComparisonData"
      (changeEvent)="handleMenuAction($event, 'inventory-turnover')"
    >
    </enhanced-kpi-widget>

    <!-- Inventory Investment Pie Chart KPI Widget -->
    <pie-chart-kpi
      [widgetTitle]="'Inventory Investment'"
      [currentValue]="inventoryInvestmentCurrent"
      [targetValue]="inventoryInvestmentTarget"
      [layout]="'vertical'"
      [widthClass]="kpiWidgetWidthClass"
      [menuItems]="ellipsisDataItems"
      widgetId="inventory-investment"
      (changeEvent)="handleMenuAction($event, 'inventory-investment')"
    >
    </pie-chart-kpi>

    <!-- Inventory Investment by Location - Grouped Breakdown KPI Widget -->
    <group-breakdown-kpi-widget
      [widgetTitle]="'Inventory Investment'"
      [totalValue]="inventoryLocationTotalValue"
      [currencySymbol]="'$'"
      [breakdownItems]="inventoryLocationBreakdownItems"
      [widthClass]="kpiWidgetWidthClass"
      [menuItems]="ellipsisDataItems"
      widgetId="inventory-location"
      [maxVisibleItems]="3"
      (changeEvent)="handleMenuAction($event, 'inventory-location')"
    >
    </group-breakdown-kpi-widget>

    

    <!-- Gauge KPI Widget - Exceptions -->
    <gauge-kpi-widget
      widgetTitle="Exceptions"
      [value]="exceptionsValue"
      description="Exceptions Total"
      [thresholds]="exceptionsThresholds"
      [minValue]="0"
      [maxValue]="600"
      [widthClass]="gaugeWidgetWidthClass"
      [menuItems]="ellipsisDataItems"
      widgetId="exceptions"
      (changeEvent)="handleMenuAction($event, 'exceptions')"
    >
    </gauge-kpi-widget>

    <!-- Forecast Accuracy Widget -->
    <forecast-widget
      #forecastWidget
      [data]="forecastWidgetData"
      [widthClass]="forecastWidgetWidthClass"
      [menuItems]="ellipsisDataItems"
      widgetId="forecast"
      (changeEvent)="handleMenuAction($event, 'forecast')"
    >
    </forecast-widget>

    <!-- Threshold Performance Analysis Widget -->
    <div class="widget-card" [ngClass]="thresholdChartWidthClass" *ngIf="isLtpFeatureEnabled">
      <div class="widget-header">
        <div class="chart-title">
          <span class="title-text">Threshold Performance Analysis</span>
        </div>
        <gains-ellipsis-menu class="ellipsis-button" [menuItems]="ellipsisDataItems" (changeEvent)="handleMenuAction($event, 'threshold')"></gains-ellipsis-menu>
      </div>
      <threshold-chart [data]="thresholdChartData" [chartWidth]="thresholdChartWidthClass"></threshold-chart>
    </div>
    <!-- ML vs Legacy Accuracy Comparison Widget -->
    <div class="widget-card" [ngClass]="mlComparisonWidthClass" *ngIf="isLtpFeatureEnabled">
      <div class="widget-header">
        <div class="chart-title">
          <span class="title-text">ML vs Legacy Accuracy Comparison</span>
        </div>
        <gains-ellipsis-menu class="ellipsis-button" [menuItems]="ellipsisDataItems" (changeEvent)="handleMenuAction($event, 'ml-comparison')"></gains-ellipsis-menu>
      </div>
      <ml-comparison-chart [data]="mlComparisonData"> </ml-comparison-chart>
    </div>

    <!-- Predicted Probability Distribution Widget -->
    <div class="widget-card" [ngClass]="mlPerformanceWidthClass" *ngIf="isLtpFeatureEnabled">
      <div class="widget-header">
        <div class="chart-title">
          <span class="title-text">Predicted Probability Distribution</span>
          <svg-icon
            src="assets/icons/circle-question.svg"
            class="title-icon"
            [title]="
              'The probability that the ML prediction will outperform the baseline/legacy prediction for a SKU-Location. Range: 0.0 (ML unlikely to be better) to 1.0 (ML very likely to be better).'
            "
            [attr.aria-label]="'Predicted Probability Distribution Information'"
          >
          </svg-icon>
        </div>
        <gains-ellipsis-menu class="ellipsis-button" [menuItems]="ellipsisDataItems" (changeEvent)="handleMenuAction($event, 'ml-performance')"></gains-ellipsis-menu>
      </div>
      <ml-performance-distribution [size]="getWidgetSize(mlPerformanceWidthClass)"></ml-performance-distribution>
    </div>
  </div>
</div>
